import type { ClientConfig } from '@/api/generated/types'
import { StorageKeys, storageService } from '@/utils/localStorageService'
import { structuralOf } from '@/utils/spec/structuralFields'

/**
 * ЧЕРНОВИК ФИЛЬТРОВ ОКНА ПОИСКА — переживает закрытие окна, уход на оплату и перезагрузку. До 2026-10-15
 * черновик жил только в сторе окна: крестик, Esc, «Buy» (страница уходит на форму оплаты) и перезагрузка
 * стирали правки, и окно открывалось заново со снимком записи. Так появился поиск 1074 Майка — точная копия
 * 1073 через восемь минут после «Buy»: правки пропали, кнопка нажата ещё раз.
 *
 * Один черновик на запись поиска (`new` — окно New search). Хранятся ТОЛЬКО фильтры (structuralFields.ts):
 * продукт берётся из записи или рабочей спеки при каждом открытии, и устаревший черновик не перепишет его.
 * Черновик забывается, когда поиск по нему начат (SearchSheet.startRun): дальше правда — запись прогона.
 */
export const draftKeyFor = (recordId: string | null): string => `${StorageKeys.searchDraft}${recordId ?? 'new'}`

export const loadDraft = (key: string): Partial<ClientConfig> | null => storageService.getItem<Partial<ClientConfig>>(key)

export const saveDraft = (key: string, spec: Partial<ClientConfig>): void => {
  storageService.setItem(key, structuralOf(spec))
}

export const forgetDraft = (key: string): void => {
  storageService.removeItem(key)
}

/** Выход из кабинета: черновиков больше нет, как и записей, к которым они относились. */
export const forgetAllDrafts = (): void => {
  try {
    const keys: string[] = []
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i)
      if (key && key.startsWith(StorageKeys.searchDraft)) keys.push(key)
    }
    keys.forEach((key) => window.localStorage.removeItem(key))
  } catch {
    /* Хранилища нет (приватное окно, запрет) — забывать нечего. */
  }
}
